<template>
    <div id="CreateComment">
        <h3>{{ $t("task.comments") }}</h3>
        <div class="add-comment">
            <Avatar
                :size="35"
                :src="user.gravatar"
                :username="user.name"
            />
            <input
                type="text"
                class="comment-input"
                v-model="commentText"
                :placeholder="$t('task.addAComment')"
            />
            <button class="comment-submit-btn" @click="submitComment">{{ $t("task.addComment") }}</button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Avatar from "vue-avatar";

export default {
    name: "CreateComment",
    props: {
        taskId: {
            type: String,
            required: true,
        },
    },
    components: {
        Avatar,
    },
    data() {
        return {
            commentText: "",
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            createComment: "comments/createComment",
            fetchCommentsAction: "comments/fetchComments",
        }),
        async fetchComments() {
            try {
                await this.fetchCommentsAction({
                    siteId: this.site._id,
                    type: "task",
                    id: this.taskId,
                });
            } catch (error) {
                console.error("Error fetching comments:", error);
            }
        },
        async submitComment() {
            if (this.commentText.trim() === "") {
                return;
            }
            try {
                await this.createComment({
                    commentData: {
                        task: this.taskId,
                        message: this.commentText,
                        user: this.user._id,
                        type: "task",
                    },
                });
                this.commentText = "";
                this.fetchComments();
            } catch (error) {
                console.error("Error creating comment:", error);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#CreateComment {
    margin-top: 30px;
    margin-bottom: 30px;
    max-width: 600px;

    h3 {
        font-size: 18px;
        margin-bottom: 15px;
        color: #333;
        font-weight: 600;
        position: relative;
        padding-bottom: 8px;
        
        &:after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 60px;
            height: 3px;
            background: linear-gradient(to right, #ec4b1d, #ff8a65);
            border-radius: 3px;
        }
    }

    .add-comment {
        display: flex;
        align-items: center;
        gap: 15px;
        padding: 20px;
        background-color: #ffffff;
        border-radius: 12px;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
        transition: all 0.3s ease;
        border: 1px solid rgba(0, 0, 0, 0.05);

        &:hover {
            box-shadow: 0 12px 28px rgba(0, 0, 0, 0.1);
            transform: translateY(-2px);
        }

        .comment-input {
            flex-grow: 1;
            padding: 12px 18px;
            background: #f9f9f9;
            border: 1px solid #e0e0e0;
            border-radius: 30px;
            font-size: 14px;
            color: #333;
            transition: all 0.3s ease;
            height: 46px;

            &:focus {
                background-color: #fff;
                border-color: #ec4b1d;
                box-shadow: 0 0 0 3px rgba(236, 75, 29, 0.2);
                outline: none;
            }

            &::placeholder {
                color: #aaa;
                font-style: italic;
            }
        }

        .comment-submit-btn {
            padding: 12px 24px;
            background: linear-gradient(135deg, #ec4b1d, #f06e48);
            border: none;
            border-radius: 30px;
            color: white;
            font-weight: 600;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 4px 10px rgba(236, 75, 29, 0.3);
            min-width: 120px;
            letter-spacing: 0.5px;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
                background: linear-gradient(135deg, #d13a0d, #ec4b1d);
                box-shadow: 0 6px 15px rgba(236, 75, 29, 0.4);
                transform: translateY(-2px);
            }

            &:active {
                transform: translateY(1px);
                box-shadow: 0 2px 8px rgba(236, 75, 29, 0.3);
            }
        }
    }
}
</style>
